import { FieldRootProps, TextareaProps } from '@chakra-ui/react';
import { Control, Controller, useController } from 'react-hook-form';
import MTextarea from './MTextarea';
import MFormField from './MFormField';

export interface MIEmailTextareaProps extends FieldRootProps {
  // v2's `FormControlProps` carried `label`; v3's `FieldRootProps` doesn't.
  label?: string;
  tooltip: string;
  fieldName: string;
  placeholder: string;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  control: Control<any>;
  textAreaProps?: TextareaProps;
  dataTestId?: string;
}

const MEmailTextarea = ({
  label,
  control,
  tooltip,
  fieldName,
  placeholder,
  isDisabled = false,
  isReadOnly = false,
  textAreaProps,
  dataTestId = 'email-text-area',
}: MIEmailTextareaProps) => {
  const variant = isReadOnly ? 'readonly' : 'outline';

  const {
    formState: { errors },
  } = useController({ name: fieldName, control });
  return (
    <MFormField
      error={errors?.[fieldName]}
      label={label}
      tooltip={tooltip}
      data-testid={dataTestId}
    >
      <Controller
        name={fieldName}
        control={control}
        render={({ field: { value, ...rest } }) => (
          <MTextarea
            isDisabled={isDisabled}
            isReadOnly={isReadOnly}
            variant={variant}
            value={value || ''}
            placeholder={placeholder}
            spellCheck={false}
            rows={2}
            minH={8}
            {...textAreaProps}
            {...rest}
          />
        )}
      />
    </MFormField>
  );
};

export default MEmailTextarea;
